import { render, staticRenderFns } from "./AdminPage.vue?vue&type=template&id=6bb0d973&scoped=true&"
import script from "./AdminPage.vue?vue&type=script&lang=js&"
export * from "./AdminPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminPage.vue?vue&type=style&index=0&id=6bb0d973&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb0d973",
  null
  
)

export default component.exports